export * from "./getPage";
export * from "./getPageGameGenre";
export * from "./getList";
export * from "./getFavorites";
export * from "./getLastPlayed";
export * from "./ListSortMethod";
export * from "./getMenu";
export * from "./getGenres";
